const detailsForAllResumes = {
    tpm: {
        companyName: 'Texas Precious Metals',
        location: 'Shiner, TX',
        jobTitle: 'Contract UX Designer / Developer',
        dates: '02/2023 — Present'
    },
    techless: {
        companyName: 'Techless',
        location: 'Shiner, TX',
        jobTitle: 'UX/UI Lead',
        dates: '05/2020 — 12/2022'
    },
    dexter: {
        companyName: 'Dexter Solutions',
        location: 'Springfield, MO',
        jobTitle: 'Marketing Coordinator',
        dates: '03/2014 — 01/2020'
    },
    nbd: {
        companyName: 'Nick Burgher Design',
        location: ' ',
        jobTitle: 'Freelance Design & Photography',
        dates: '09/2015 — Present'
    },
    marketingBunch: {
        companyName: 'The Marketing Bunch',
        location: 'Bolivar, MO',
        jobTitle: 'Graphic Designer',
        dates: '08/2013 — 03/2014'
    },
    sbu: {
        companyName: 'Southwest Baptist University',
        location: 'Bolivar, MO',
        jobTitle: 'Undergraduate',
        dates: '08/2009 — 12/2013',
        details: [
            'BS, Commercial Art: Graphic Design',
            'BS, General Music (Piano)',
            'Graduating GPA of 3.94'
        ]
    },
    highlights: [
        'Private Piano Instructor (2019 — present)',
        'Church volunteer: musician, young adult Bible teacher (present)',
        'Heart Academy of Music Board of Directors, 2015 — 2017',
        'Outstanding Art Student 2014, Southwest Baptist University',
        'Member of Pi Kappa Lambda (National Music Honor Society)'
    ]

}
export default detailsForAllResumes;